<div class="formula-tool-container">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <h3>Formula Test Cases</h3>
      <div class="subtitle">Save formulas with expected results and re-run them to catch regressions.</div>
    </div>
    <div>
      <!-- Both run every active test case in the database, regardless of the list filters/page.
           Dry Run evaluates without saving statuses or audit rows; its button is hidden
           unless enabled from the browser console (enableFormulaDryRun()). -->
      <button *ngIf="dryRunEnabled" class="btn-secondary" (click)="runAll(true)" [disabled]="!totalCount" title="Evaluate all active test cases without saving results">Dry Run All</button>
      <button class="btn-secondary" (click)="runAll()" [disabled]="!totalCount">Run All (Active Only)</button>
      <button class="btn-primary" (click)="addNew()">Add New</button>
    </div>
  </div>

  <div class="filter-row">
    <input type="text" [(ngModel)]="searchKey" (ngModelChange)="onSearchChange()" placeholder="Filter by name or strategy name..."/>
    <select [(ngModel)]="typeFilter" (ngModelChange)="onFilterChange()">
      <option value="">All Types</option>
      <option value="BOOLEAN">Trigger Formula</option>
      <option value="NUMERIC">Plan Amount</option>
      <option value="STRING">Why Description</option>
    </select>
    <select [(ngModel)]="lastRunFilter" (ngModelChange)="onFilterChange()">
      <option value="">All Runs</option>
      <option value="PASS">Pass</option>
      <option value="FAIL">Fail</option>
      <option value="NOT_RUN">Not Run</option>
    </select>
    <select [(ngModel)]="statusFilter" (ngModelChange)="onFilterChange()">
      <option value="ACTIVE">Active</option>
      <option value="INACTIVE">Inactive</option>
      <option value="ALL">All Statuses</option>
    </select>
  </div>

  <div class="dry-run-panel" *ngIf="runAllResult" [class.dry-run-pass]="!runAllResult.failed.length" [class.dry-run-fail]="runAllResult.failed.length">
    <div class="dry-run-header">
      <span>
        {{runAllResult.dryRun ? 'Dry run' : 'Run all'}} at {{runAllResult.at | date:'shortTime'}} —
        <ng-container *ngIf="!runAllResult.failed.length">all {{runAllResult.total}} test cases passed</ng-container>
        <ng-container *ngIf="runAllResult.failed.length">{{runAllResult.failed.length}} of {{runAllResult.total}} test cases failed</ng-container>
        <ng-container *ngIf="runAllResult.dryRun"> (results not saved)</ng-container>
      </span>
      <button type="button" class="link-btn" (click)="runAllResult = null">Dismiss</button>
    </div>
    <div class="dry-run-failures" *ngIf="runAllResult.failed.length">
      <div class="dry-run-failure" *ngFor="let failure of runAllResult.failed">
        <strong>{{failure.name}}</strong>
        <span class="mono" *ngIf="!failure.errorMessage"> — expected {{failure.expectedResult}}, got {{failure.actualResult || '(none)'}}</span>
        <span class="error-text" *ngIf="failure.errorMessage"> — {{failure.errorMessage}}</span>
      </div>
    </div>
  </div>

  <div class="empty-state" *ngIf="!totalCount && !hasAnyFilter()">No formula test cases yet. Click "Add New" to create one.</div>
  <div class="empty-state" *ngIf="!totalCount && hasAnyFilter()">No test cases match the current filters.</div>

  <table class="formula-table" *ngIf="testCases.length">
    <thead>
    <tr>
      <th>Name</th>
      <th>Status</th>
      <th>Type</th>
      <th>Strategy</th>
      <th>Formula</th>
      <th>Last Run</th>
      <th>Last Run At</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let testCase of testCases" [class.inactive-row]="!testCase.active">
      <td>{{testCase.name}}</td>
      <td>
        <span class="active-badge" [ngClass]="{'active-yes': testCase.active, 'active-no': !testCase.active}">
          {{testCase.active ? 'Active' : 'Inactive'}}
        </span>
      </td>
      <td>{{formulaTypeLabel(testCase.formulaType)}}</td>
      <td>
        <span *ngIf="testCase.sourceRuleId" class="strategy-badge" [title]="testCase.sourceRuleName || ''">
          {{testCase.sourceStrategyName || 'Unknown strategy'}}
        </span>
        <span *ngIf="!testCase.sourceRuleId" class="custom-badge">Custom</span>
      </td>
      <td class="formula-cell" [title]="testCase.resolvedFormula">{{testCase.resolvedFormula}}</td>
      <td>
          <span class="status-badge" [ngClass]="{
            'status-pass': testCase.lastRunStatus === 'PASS',
            'status-fail': testCase.lastRunStatus === 'FAIL',
            'status-none': !testCase.lastRunStatus
          }">{{testCase.lastRunStatus || 'NOT RUN'}}</span>
      </td>
      <td>{{testCase.lastRunAt || '-'}}</td>
      <td class="actions">
        <button class="link-btn" (click)="run(testCase)">Run</button>
        <button class="link-btn" (click)="edit(testCase)">Edit</button>
        <span class="action-menu-wrap">
          <button class="menu-btn" [class.menu-open]="openMenuId === testCase.id"
                  (click)="toggleMenu(testCase, $event)" title="More actions">&#8943;</button>
          <div class="action-menu" *ngIf="openMenuId === testCase.id">
            <button (click)="viewHistory(testCase); closeMenu()">History</button>
            <button (click)="duplicate(testCase); closeMenu()">Duplicate</button>
            <button (click)="toggleActive(testCase); closeMenu()">{{testCase.active ? 'Deactivate' : 'Activate'}}</button>
            <button class="danger" (click)="remove(testCase); closeMenu()">Delete</button>
          </div>
        </span>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="pagination-row" *ngIf="totalCount">
    <span class="page-info">Page {{page}} of {{totalPages()}} ({{totalCount}} test case{{totalCount === 1 ? '' : 's'}})</span>
    <button class="btn-secondary" (click)="prevPage()" [disabled]="page <= 1">Previous</button>
    <button class="btn-secondary" (click)="nextPage()" [disabled]="page >= totalPages()">Next</button>
    <select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange()">
      <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{size}} per page</option>
    </select>
  </div>
</div>

<div *ngIf="reveal">
  <div class="reveal-overlay" (click)="hideReveal()"></div>
  <div class="reveal-panel">
    <div class="reveal-header">
      <span>{{editMode ? 'Edit' : 'Add'}} Formula Test Case</span>
      <span class="pointer" (click)="hideReveal()">X</span>
    </div>
    <app-formula-test-case-form
      [editMode]="editMode"
      [testCase]="selectedTestCase"
      (onCancel)="hideReveal()"
      (onSave)="onSaved()">
    </app-formula-test-case-form>
  </div>
</div>

<div *ngIf="historyReveal">
  <div class="reveal-overlay" (click)="hideHistory()"></div>
  <div class="reveal-panel">
    <div class="reveal-header">
      <span>Run History — {{historyTestCase?.name}}</span>
      <span class="pointer" (click)="hideHistory()">X</span>
    </div>
    <div class="history-body">
      <div class="empty-state" *ngIf="!historyLoading && !historyRuns.length">No runs recorded yet for this test case.</div>
      <div class="history-run" *ngFor="let run of historyRuns">
        <div class="history-run-header">
          <span class="status-badge" [ngClass]="{'status-pass': run.passed, 'status-fail': !run.passed}">
            {{run.passed ? 'PASS' : 'FAIL'}}
          </span>
          <span class="source-badge" [ngClass]="{'source-automated': run.runSource === 'AUTOMATED'}">{{run.runSource}}</span>
          <span class="history-run-meta">{{run.runAt}} by {{run.runBy || 'unknown'}}</span>
        </div>
        <div class="history-run-detail">
          <div><strong>Formula:</strong> <span class="mono">{{run.formulaUsed}}</span></div>
          <div><strong>Input:</strong> <span class="mono">{{run.inputValuesUsed}}</span></div>
          <div><strong>Expected:</strong> <span class="mono">{{run.expectedResult}}</span> &nbsp; <strong>Actual:</strong> <span class="mono">{{run.actualResult}}</span></div>
          <div class="error-text" *ngIf="run.errorMessage"><strong>Error:</strong> {{run.errorMessage}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
